import React, { Component } from 'react';

import { Card, CardTitle } from 'material-ui/Card';

import DetailView from '../Common/DetailView';

class Reminder extends Component {

    render() {

        return(
            <DetailView 
                title="Reminder"
                backButton={true}
            >
                <Card className="cent-card">
                    <CardTitle title="Reminder" />
                </Card>
            </DetailView>
        );
    }

}

export default Reminder;
